<template>
  <div class="list-wrap">
    <div class="list-container">
      <template v-for="(item, idx) in props.list" :key="idx">
         <!-- 每隔2个item插入广告占位容器 -->
          <div
          v-if="(idx) % 2 === 0"
          class="ad-container"
          :id="'ad-container-' + (idx)/2"
          :ref="el => adRefs[idx] = el"
        ></div>
        <ListItem :data="item" />
        <!-- 当渲染到最后一个项时触发方法 -->
        <div v-if="idx === props.list.length - 1" class="trigger-mount" />
      </template>
    </div>
  </div>
</template>

<script setup>
import { defineProps, ref, watch } from 'vue';
import ListItem from "./list-item.vue";

const props = defineProps({
  list: Array
});

// 创建一个 refs 数组，用于保存广告容器的 DOM 引用
const adRefs = ref([]);
// 监听 props.list 的变化
watch(
  () => props.list,
  (newList) => {
    if (newList.length > 0) {
      setTimeout(() => {
        handleLastElementRendered();
      }, 500);
    }
  },
  { immediate: true }
);
const handleLastElementRendered = () => {
    for (let i = 0; i < props.list.length; i++) {
      let index = i/2;
      let adContainer = document.getElementById('ad-container-' + index);
      if (adContainer && adContainer.childNodes.length ==0) {
         // 动态创建广告脚本
         const adScript = document.createElement("script");
        adScript.type = "text/javascript";
        adScript.innerHTML = `
          QIHOO_WAP_FEEDAD({
            h: 220, // 选填，广告位区域高度（不传值则按模板默认高度展示）
            placeholderId: 'ad-container-${index}', // 异步插入必填! 指定插入位置-广告容器id，同步插入不需要此参数
            showid: 'SsrZ59',
            adOptions: {
              queryword: "装修 洗发水 马桶 借钱 男装 女装 袜子",
              title: encodeURIComponent(document.title),
              uid: "${Date.now()}-${Math.random().toString(36).substr(2, 9)}"
            },
            onFail: function(e) { console.log(e,'-fail-') },
            onSuccess: function() { console.log('-success-') },
            onClose: function() { console.log('-close-') }
          });
        `;
        index=index+1;
        adContainer.appendChild(adScript);
      }
    }
   
  };
</script>

<style lang="less">
.list-wrap {
  margin-top: 48px;
  background: #fff;
  padding-top: 24px;

  .list-container {
    padding: 24px;

    .textImg {
      .adm-list-item-content {
        display: flex;
        padding: 24px 0;
        border-bottom: 1px solid #eee;

        .adm-image {
          width: 240px;

          & > img {
            width: 100%;
          }
        }

        .adm-list-item-content-main {
          flex: 1;
          flex: auto;
          font-size: 34px;
        }

        .adm-list-item-description {
          .tips {
            display: flex;
            justify-content: space-between;

            span {
              float: left;
              font-size: 24px;
              color: rgb(0, 0, 0);
              font-family: 微软雅黑;
              line-height: 32px;
            }
          }
        }
      }
    }

    .ad-container {
      margin: 20px 0;
      text-align: center;
      height: 220;
    }
  }
}
</style>
